import React, { Fragment } from 'react';

import _ from 'lodash';
import { GridLine } from './GridLine';
import { rosterConfig } from '../../roster-config';

const { TIMELINE_ROW_HEIGHT, TIMELINE_HOUR_BLOCK_WIDTH } = rosterConfig;

interface GridLinesProps {
  hours: any[];
  rowCount?: number;
}

export function Gridlines({ hours, rowCount = 0 }: GridLinesProps) {
  const height = `${TIMELINE_ROW_HEIGHT * rowCount}px`;

  return (
    <>
      {_.map(hours, (hour, idx) => (
        <Fragment key={idx}>
          <GridLine type='solid' offset={(idx + 1) * TIMELINE_HOUR_BLOCK_WIDTH} height={height} />
          <GridLine
            type='dotted'
            offset={idx * TIMELINE_HOUR_BLOCK_WIDTH + TIMELINE_HOUR_BLOCK_WIDTH / 2}
            height={height}
          />
        </Fragment>
      ))}
    </>
  );
}
